export const selectAccountTab = (state) => state?.accountSettings?.accountTab;
export const selectScrollSection = (state) => state?.accountSettings?.scrollSection;
export const selectAdvancedSettingsTab = (state) => state?.accountSettings?.advancedSettingsTab;
export const selectUsers = (state) => state?.accountSettings?.users;
export const selectInvites = (state) => state?.accountSettings?.invites;
